import { Button, Input } from 'reactstrap';
import {
  DailyScheduleEmployeeDTO,
  DailyScheduleRoomDTO,
  HighlightColor,
} from '../../../../interfaces/DailyScheduleInterface';
import ScheduleEntryRow from './ScheduleEntryRow';

interface Props {
  room: DailyScheduleRoomDTO;
  employees: DailyScheduleEmployeeDTO[];
  onRoomNameChange: (roomId: string, name: string) => void;
  onRoomColorChange: (roomId: string, color: HighlightColor) => void;
  onRemoveRoom: (roomId: string) => void;
  onAddEntry: (roomId: string) => void;
  onEntryChange: (entryId: string, field: string, value: any) => void;
  onRemoveEntry: (entryId: string) => void;
}

const COLOR_OPTIONS: { value: HighlightColor; label: string; css: string }[] = [
  { value: null, label: 'None', css: 'c-none' },
  { value: 'yellow', label: 'Yellow', css: 'c-yellow' },
  { value: 'pink', label: 'Pink', css: 'c-pink' },
  { value: 'green', label: 'Green', css: 'c-green' },
];

const RoomSection = ({
  room,
  employees,
  onRoomNameChange,
  onRoomColorChange,
  onRemoveRoom,
  onAddEntry,
  onEntryChange,
  onRemoveEntry,
}: Props) => (
  <>
    <tr className="room-header">
      <td colSpan={6}>
        <div className="d-flex align-items-center gap-2 flex-wrap" style={{ gap: '0.5rem' }}>
          <Input
            style={{ maxWidth: 200, display: 'inline-block', fontWeight: 600 }}
            bsSize="sm"
            value={room.roomName}
            onChange={(e) => onRoomNameChange(room.id, e.target.value)}
          />
          <div className="d-inline-flex align-items-center ml-2">
            {COLOR_OPTIONS.map((c) => (
              <span
                key={String(c.value)}
                className={`color-circle ${c.css} ${room.highlightColor === c.value ? 'active' : ''}`}
                onClick={() => onRoomColorChange(room.id, c.value)}
                title={c.label}
              />
            ))}
          </div>
          <Button color="success" outline size="sm" className="ml-2" onClick={() => onAddEntry(room.id)}>
            + Add Staff
          </Button>
          <Button color="danger" outline size="sm" className="ml-1" onClick={() => onRemoveRoom(room.id)}>
            Remove Room
          </Button>
        </div>
      </td>
    </tr>
    {room.entries.map((entry) => (
      <ScheduleEntryRow
        key={entry.id}
        entry={entry}
        roomName={room.roomName}
        highlightColor={room.highlightColor}
        employees={employees}
        onChange={onEntryChange}
        onRemove={onRemoveEntry}
      />
    ))}
    {room.entries.length === 0 && (
      <tr className={room.highlightColor ? `row--${room.highlightColor}` : ''}>
        <td colSpan={6} className="text-center text-muted" style={{ fontSize: '0.82rem', padding: '0.75rem' }}>
          No staff assigned. Click &quot;+ Add Staff&quot; to add.
        </td>
      </tr>
    )}
  </>
);

export default RoomSection;
